import React, { useState } from "react";
import { useLocation } from "react-router-dom";
import { Container, Row, Col } from "react-bootstrap";
import Topbar from "../Topbar/Topbar";
import moment from "moment";
import "./AddDues.css";
import { FaStarOfLife } from "react-icons/fa6";
import { FiUpload } from "react-icons/fi"; // Close & Upload icons
import axios from "axios";
import Swal from "sweetalert2";
import { useEffect } from "react";
import { MdEdit } from "react-icons/md";
import MessageBox from "../MessageBox/MessageBox";
import { useSelector } from "react-redux";

const statusOptions = [
  { value: "Open", color: "#fbdc6e" },
  { value: "Paid", color: "#a7e9a1" },
  { value: "Reminder 1", color: "#c4a5f3" },
  { value: "Reminder 2", color: "#c7a47b" },
  { value: "Reminder 3", color: "#f9b2e2" },
  { value: "> 3 Reminder", color: "#e66767" },
  { value: "Suspended", color: "#c0c3ca" },
  { value: "Disable", color: "#fca672" },
];

export default function ViewDues() {
  const staffName = useSelector((state) => state.staffname);
  const Id = useSelector((state) => state.id);


  const locate = useLocation();
  const hideButtons =
    locate.state?.hideButtons === true || locate.state?.hideButtons === "true";

  const apiUrl = process.env.REACT_APP_API_BASE_URL;
  const [selectedFile, setSelectedFile] = useState(null);
    const handleFileChange = (event) => {
    setSelectedFile(event.target.files[0]);
  };
  //edit
  const [messageData, setMessageData] = useState([]);
  const [pageRefId, setpageRefId] = useState("");
  const [showMessageBox, setShowMessageBox] = useState(false);
  const [isEditing, setIsEditing] = useState(false);

  const location = useLocation();

  //fetch data from customer page state

  const [customerid, setCustomerId] = useState("");
  const [customerData, setCustomerData] = useState(null);
  const [error, setError] = useState();

  //staff
  const [staffData, setstaffData] = useState([]);
  //write state to get dues schema
  const [viewDuesData, setViewDuesData] = useState({
    dueId: "",
    createdAt: "",
    dueOpenLastDay: "",
    customerid: "",
    customername: "",
    contactnum: "",
    alternatenum: "",
    invoiceDate: "",
    followupPerson: "",
    totalBillAmount: "",
    dueAmount: "",
    dueStatus: "",
    dueLeadstatus: {
      dueNotes: "",
      dueImage: "",
      dueExpectedPaymentDate: "",
    },
  });
  const selectedDueStatus = viewDuesData?.dueStatus;
  //merge the customer data and the due

  const handleDuesChange = (e) => {
    const { name, value } = e.target;

    if (name in viewDuesData.dueLeadstatus) {
      setViewDuesData((prevState) => ({
        ...prevState,
        dueLeadstatus: {
          ...prevState.dueLeadstatus,
          [name]: value,
        },
      }));
    } else {
      setViewDuesData((prevState) => ({
        ...prevState,
        [name]: value,
      }));
    }
  };

  //open status
  const [isOpenConverted, setIsOpenConverted] = useState(false);

  //submit
  const handleSave = async (e) => {
    e.preventDefault();

    const result = await Swal.fire({
      title: "Are you sure you want to update?",
      showCancelButton: true,
      confirmButtonText: "Update",
    });

    if (!result.isConfirmed) return;

    const now = new Date();
    const date = now.toLocaleDateString();
    const time = now.toLocaleTimeString();

    const updatedBy = {
      staffname: staffName,
      _id: Id,
      time: time,
      date: date,
    };

    try {
      // ✅ Update dues
      const response = await axios.put(apiUrl + "update-dues", {
        id: viewDuesData._id,
        ...viewDuesData,
        updatedBy,
      });

      if (response.data?.data) {
        // ✅ Map status to color code
        let colorCode = "#fbdc6e"; // default

        switch (viewDuesData.dueStatus) {
          case "Open":
            colorCode = "#fbdc6e";
            break;
          case "Paid":
            colorCode = "#a7e9a1";
            break;
          case "Reminder 1":
            colorCode = "#c4a5f3";
            break;
          case "Reminder 2":
            colorCode = "#c7a47b";
            break;
          case "Reminder 3":
            colorCode = "#f9b2e2";
            break;
          case "> 3 Reminder":
            colorCode = "#e66767";
            break;

          case "Suspended":
            colorCode = "#c0c3ca";
            break;
          case "Disable":
            colorCode = "#fca672";
            break;
          default:
            colorCode = "#cccccc";
        }

        // ✅ Add message
        const formData = new FormData();
        formData.append("pageRefId", viewDuesData._id);
        formData.append("page", "Dues");
        formData.append(
          "description",
          viewDuesData?.dueLeadstatus?.dueNotes || ""
        ); // Optional notes field
        formData.append("staffPic", "");
        if (selectedFile) {
          formData.append("image", selectedFile);
        }
        formData.append("updatesHistory[staff][name]", staffName);
        formData.append("updatesHistory[staff][id]", Id);
        formData.append("updatesHistory[status]", viewDuesData.dueStatus);
        formData.append("colorCode", colorCode);

        await axios.post(apiUrl + "add-message", formData, {
          headers: { "Content-Type": "multipart/form-data" },
        });

        // ✅ Refresh messages (optional)
        const res = await axios.get(`${apiUrl}messages/${viewDuesData._id}`);
        setMessageData(res.data.data);
        setShowMessageBox(true);
        setIsEditing(false);
        Swal.fire({
          icon: "success",
          title: "Updated!",
          text: "Dues updated successfully.",
        });
      } else {
        Swal.fire({
          icon: "error",
          title: "Update Failed",
          text: "Dues not found.",
        });
      }
    } catch (error) {
      console.error("Update error:", error);
      Swal.fire({
        icon: "error",
        title: "Error",
        text: error.response?.data?.message || error.message,
      });
    }
  };

  const handleDueStatusChange = (selectedStatus) => {
    setViewDuesData((prev) => ({
      ...prev,
      dueStatus: selectedStatus,
      dueLeadstatus: {
        ...prev.dueLeadstatus,
        dueStatus: selectedStatus,
      },
    }));
    setIsOpenConverted(true);
  };

  //fetching data for edit
  useEffect(() => {
    if (location.state?.id) {
      axios
        .post(apiUrl + "view-dues", {
          id: location.state.id,
        })
        .then((res) => {
          setViewDuesData(res.data.message);
          setpageRefId(res.data.message._id);
        })
        .catch((err) => console.error("Fetch failed", err));
    }
  }, [location.state?.id, apiUrl]);

  //fetching customer id
  useEffect(() => {
    const fetchCustomerData = () => {
      if (!customerid.trim()) {
        setCustomerData(null); // Clear data if ID is empty
        setError("");

        console.log(customerid);
        return;
      }
      axios
        .get(`${apiUrl}customer/${customerid}`)
        .then((response) => {
          setCustomerData(response.data); // Set the customer data
          setError("");
        })
        .catch((err) => {
          if (err.response?.status === 404) {
            setError("Customer not found");
          } else {
            setError("An error occurred. Please try again later.");
          }
          setCustomerData(null);
        });
    };

    fetchCustomerData();
  }, [customerid, apiUrl]);

  useEffect(() => {
    axios
      .post(
        apiUrl + "viewstaff",

        {}
      )
      .then((res) => {
        setstaffData(res.data.message);
      });
  }, [apiUrl]);

  useEffect(() => {
    const fetchMessages = async () => {
      try {
        const response = await axios.get(`${apiUrl}messages/${pageRefId}`);

        if (response.status === 200 && Array.isArray(response.data.data)) {
          setMessageData(response.data.data); // ✅ Only the array!
        } else {
          console.error("Unexpected response structure:", response);
          setMessageData([]); // fallback to empty array
        }
      } catch (error) {
        console.error("Error fetching messages:", error);
        setMessageData([]); // fallback to empty array
      }
    };

    fetchMessages();
  }, [apiUrl, pageRefId]);

  return (
    <>
      <Topbar />
      <Container className="mt-1    ">
        <form>
          <Row>
            <Col>
              <h3>Dues</h3>
            </Col>

            <Col className="text-end me-5">
              <>
                {!isEditing ? (
                  <>
                    <button
                      className="black-btn mx-1 my-1"
                      type="button"
                      onClick={(e) => {
                        e.preventDefault();
                        setIsEditing(true);
                      }}
                    >
                      <span>
                        <MdEdit className="mx-1 editicon-recovery" />
                      </span>
                      Edit
                    </button>
                  </>
                ) : (
                  <>
                    <button
                      className="blue-btn my-1"
                      type="button"
                      onClick={handleSave}
                    >
                      Save
                    </button>
                    <button
                      className="black-btn mx-1 my-1"
                      type="button"
                      onClick={() => setIsEditing(false)}
                    >
                      Cancel
                    </button>
                  </>
                )}
              </>
            </Col>
          </Row>

          <div className="border-container1">
            <h6 className="form-head  m-0 text-white  ">Dues Details</h6>
          </div>

          <div className="border-container ">
            <Row className="text-start lead-id-row  mb-4 mt-4 ms-4 ">
              <p className="ps-5 paragraph-lead-id">
                Due ID -{" "}
                <span className="text-primary ">{viewDuesData?.duesId}</span>{" "}
                <span className="lead-start-date">
                  {" "}
                  Due Open Last -{" "}
                  <span className="text-primary">
                    {" "}
                    {moment(viewDuesData?.createdAt).fromNow()}
                  </span>
                </span>{" "}
              </p>
            </Row>
            <Row className="ms-3">
              <Col sm={12} md={6} className="text-start ">
                <Row>
                  <Col md={6} sm={12}>
                    {" "}
                    <lable>Customer Id</lable>
                    <br />
                    <input
                      type="text"
                      style={{ textTransform: "capitalize " }}
                      className="form-input "
                      placeholder="Enter Custmer Name"
                      name="customerid"
                      value={viewDuesData?.customerid}
                      onChange={(e) => {
                        setCustomerId(e.target.value); // Update the state
                        handleDuesChange(e);
                      }}
                      disabled
                    />
                    {error && <p style={{ color: "red" }}>{error}</p>}
                  </Col>
                  <Col md={6} sm={12}>
                    {" "}
                    <lable>Customer Name</lable>
                    <br />
                    <input
                      type="text"
                      style={{ textTransform: "capitalize " }}
                      className="form-input "
                      placeholder="Enter Custmer Name"
                      name="customername"
                      value={viewDuesData?.customername}
                      onChange={handleDuesChange}
                      readOnly
                      disabled
                    />
                  </Col>
                </Row>
              </Col>

              <Col>
                <Row>
                  <Col xs={12} md={6} className="text-start">
                    <lable>
                      Contact Number
                      <sup>
                        <FaStarOfLife size={7} />
                      </sup>
                    </lable>
                    <br />
                    <input
                      type="tel"
                      onKeyDown={(e) => {
                        if (
                          ["e", "E", "+", "-"].includes(e.key) ||
                          (e.key &&
                            !/[0-9]/.test(e.key) &&
                            e.key !== "Backspace" &&
                            e.key !== "ArrowLeft" &&
                            e.key !== "ArrowRight")
                        ) {
                          e.preventDefault();
                        }
                      }}
                      placeholder="Enter Phone Number"
                      className="form-input"
                      name="contactnum"
                      maxLength={10}
                      value={viewDuesData?.contactnum}
                      required
                      readOnly
                      onChange={handleDuesChange}
                      disabled
                    />
                  </Col>

                  <Col xs={12} md={6} className="text-start">
                    <lable>Alternate Number </lable>
                    <br />
                    <input
                      type="tel"
                      onKeyDown={(e) => {
                        if (
                          ["e", "E", "+", "-"].includes(e.key) ||
                          (e.key &&
                            !/[0-9]/.test(e.key) &&
                            e.key !== "Backspace" &&
                            e.key !== "ArrowLeft" &&
                            e.key !== "ArrowRight")
                        ) {
                          e.preventDefault();
                        }
                      }}
                      name="alternatenum"
                      value={viewDuesData?.alternatenum}
                      maxLength={10}
                      className="form-input"
                      placeholder="Enter Phone Number"
                      onChange={handleDuesChange}
                      disabled
                    />
                  </Col>
                </Row>
              </Col>
            </Row>

            <Row className="ms-3">
              <Col xs={12} md={6} className="text-start">
                <Row>
                  <Col xs={12} md={6} className="text-start">
                    <lable>Invoice Date</lable>
                    <br />
                    <input
                      type="date"
                      placeholder="Enter Phone Number"
                      className="form-input"
                      name="invoiceDate"
                      value={
                        viewDuesData?.invoiceDate
                          ? new Date(viewDuesData.invoiceDate)
                              .toISOString()
                              .split("T")[0]
                          : ""
                      }
                      maxLength={10}
                      required
                      onChange={handleDuesChange}
                      disabled={!isEditing}
                    />
                  </Col>

                  <Col xs={12} md={6} className="text-start">
                    <label>Follow up Person</label>
                    <br />
                    <select
                      className="dropbtn form-input-select"
                      name="followupPerson"
                      value={viewDuesData?.followupPerson || ""}
                      onChange={handleDuesChange}
                      disabled={!isEditing}
                      // style={{
                      //   padding: "10px",
                      //   width: "85%",
                      //   border: "2px solid #a7a7a7",
                      //   borderRadius: "4px",
                      //   backgroundColor: isEditing ? "#fff" : "#f3f3f3",
                      //   marginTop: "10px",
                      // }}
                    >
                      <option value="">Select staff</option>
                      {staffData.length > 0 ? (
                        staffData.map((staff) => (
                          <option key={staff._id} value={staff.staffName}>
                            {staff.staffName}
                          </option>
                        ))
                      ) : (
                        <option disabled>Loading staff...</option>
                      )}
                    </select>
                  </Col>
                </Row>
              </Col>
              <Col>
                <Row>
                  <Col xs={12} md={6} className="text-start">
                    <lable>Total Bill Amount</lable>
                    <br />
                    <input
                      style={{ textTransform: "capitalize" }}
                      className="form-input"
                      type="tel"
                      onKeyDown={(e) => {
                        if (
                          ["e", "E", "+", "-"].includes(e.key) ||
                          (e.key &&
                            !/[0-9]/.test(e.key) &&
                            e.key !== "Backspace" &&
                            e.key !== "ArrowLeft" &&
                            e.key !== "ArrowRight")
                        ) {
                          e.preventDefault();
                        }
                      }}
                      disabled={!isEditing}
                      placeholder="Enter Location"
                      name="totalBillAmount"
                      value={viewDuesData?.totalBillAmount || ""}
                      onChange={handleDuesChange}
                      // disabled={!isEditMode}
                    />
                  </Col>
                  <Col xs={12} md={6} className="text-start">
                    <lable>Due Amount</lable>
                    <br />

                    <input
                      style={{ textTransform: "capitalize" }}
                      className="form-input"
                      type="tel"
                      onKeyDown={(e) => {
                        if (
                          ["e", "E", "+", "-"].includes(e.key) ||
                          (e.key &&
                            !/[0-9]/.test(e.key) &&
                            e.key !== "Backspace" &&
                            e.key !== "ArrowLeft" &&
                            e.key !== "ArrowRight")
                        ) {
                          e.preventDefault();
                        }
                      }}
                      disabled={!isEditing}
                      placeholder="Enter Location"
                      name="dueAmount"
                      value={viewDuesData?.dueAmount || ""}
                      onChange={handleDuesChange}
                      // disabled={!isEditMode}
                    />
                  </Col>
                </Row>
              </Col>
            </Row>
            <Row className="ms-3">
              <Col xs={12} md={6} className="text-start"></Col>
              <Col>
                <Row>
                  <Col xs={12} md={6} className="text-start">
                    <lable>Expected Payment Date</lable>
                    <br />
                    <input
                      className="field form-input"
                      type="date"
                      name="dueExpectedPaymentDate"
                      value={
                        viewDuesData?.dueLeadstatus?.dueExpectedPaymentDate
                          ? new Date(
                              viewDuesData.dueLeadstatus.dueExpectedPaymentDate
                            )
                              .toISOString()
                              .split("T")[0]
                          : ""
                      }
                      onChange={handleDuesChange}
                      disabled
                    />
                  </Col>
                  <Col xs={12} md={6} className="text-start">
                    <Row>
                      <label>Due Status</label>
                      <br />

                      {/* // Case 1: show dropdown when hideButtons is true */}
                      <select
                        className="form-select-dues mt-2 ms-3"
                        name="dueStatus"
                        value={selectedDueStatus || ""}
                        onChange={(e) => handleDueStatusChange(e.target.value)}
                        disabled={!isEditing}
                        style={{
                          backgroundColor:
                            statusOptions.find(
                              (item) => item.value === selectedDueStatus
                            )?.color || "#fbdc6e",
                          color: "#333",
                          textTransform: "capitalize",
                          fontWeight: "bold",
                          borderRadius: "6px",
                          padding: "8px 12px",
                          width: "100%",
                          border: "1px solid #ccc",
                        }}
                      >
                        <option disabled value="">
                          Select Status
                        </option>
                        {statusOptions.map((option) => (
                          <option
                            key={option.value}
                            value={option.value}
                            style={{ backgroundColor: option.color }}
                          >
                            {option.value}
                          </option>
                        ))}
                      </select>

                      {isOpenConverted && (
                        <div className="overlay1-converted">
                          <div className="modal1-converted">
                            <Container>
                              <button
                                className="close-btn1"
                                onClick={() => setIsOpenConverted(false)}
                              >
                                <span style={{ fontSize: "20px" }}>
                                  &times;
                                </span>
                              </button>

                              <div
                                className="open-button border"
                                style={{
                                  backgroundColor:
                                    statusOptions.find(
                                      (item) =>
                                        item.value === viewDuesData?.dueStatus
                                    )?.color || "#fbdc6e",
                                  padding: "10px",
                                  borderRadius: "8px",
                                  marginBottom: "10px",
                                }}
                              >
                                <h5
                                  style={{
                                    textTransform: "capitalize",
                                    margin: 0,
                                  }}
                                >
                                  {viewDuesData?.dueStatus || ""}
                                </h5>
                              </div>

                              <textarea
                                className="converted-textbox"
                                placeholder="Enter Notes"
                                name="dueNotes"
                                value={viewDuesData?.dueLeadstatus?.dueNotes}
                                onChange={handleDuesChange}
                                style={{
                                  textTransform: "capitalize",
                                  resize: "none",
                                }}
                              />
                              <div className="upload-section">
                                <label className="upload-btn">
                                  <FiUpload className="upload-icon" />
                                  Upload Image
                                  <input
                                    type="file"
                                    accept="image/*"
                                    onChange={handleFileChange}
                                    hidden
                                  />
                                </label>
                                {selectedFile && (
                                  <p className="file-name">
                                    {selectedFile.name}
                                  </p>
                                )}
                              </div>
                              <Row>
                                <Col className="date-update-textbox">
                                  <label>Expected Payment Date</label>
                                  <br />
                                  <input
                                    type="date"
                                    className="field form-input"
                                    name="dueExpectedPaymentDate"
                                    value={
                                      viewDuesData?.dueLeadstatus
                                        ?.dueExpectedPaymentDate || ""
                                    }
                                    onChange={handleDuesChange}
                                    min={new Date().toISOString().split("T")[0]}
                                  />
                                </Col>
                                <Col className="uploadbtn-install">
                                  <button
                                    type="button"
                                    className="blue-btn"
                                    onClick={() => setIsOpenConverted(false)}
                                  >
                                    Upload
                                  </button>
                                </Col>
                              </Row>
                            </Container>
                          </div>
                        </div>
                      )}
                    </Row>
                  </Col>
                </Row>
              </Col>
            </Row>
          </div>
        </form>

        {/* {showMessageBox && ( */}
        <Row className="container ms-3 me-5">
          <Col md={6} sm={12}>
            <div>
              {Array.isArray(messageData) && messageData.length > 0 ? (
                messageData.map((msg) => (
                  <MessageBox key={msg._id} message={msg} />
                ))
              ) : (
                <div className="text-muted">No messages available.</div>
              )}
            </div>
          </Col>

          <Col md={6} sm={12}>
            <div className="compact-updates-history">
              <div className="compact-updates-header">Updates History</div>
              {Array.isArray(messageData) && messageData.length > 0 ? (
                messageData.map((data, index) => (
                  <div className="compact-update text-center" key={index}>
                    <div className="compact-update-date text-center">
                      {data.updatesHistory.date
                        ? new Date(data.updatesHistory.date).toLocaleDateString(
                            "en-GB"
                          ) +
                          " - " +
                          new Date(data.updatesHistory.date).toLocaleTimeString(
                            "en-US",
                            {
                              hour: "2-digit",
                              minute: "2-digit",
                              hour12: true,
                            }
                          )
                        : "No date"}
                    </div>

                    <div className="compact-update-user text-center">
                      {data.updatesHistory?.staff?.name || "Unknown"}
                    </div>

                    <div
                      className="compact-update-status text-center"
                      style={{ color: data.colorCode || "#000000" }}
                    >
                      {data.updatesHistory?.status || "No Status"}
                    </div>
                  </div>
                ))
              ) : (
                <div className="text-muted text-center">
                  No update history available.
                </div>
              )}
            </div>
          </Col>
        </Row>
      </Container>
    </>
  );
}
